import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Form.css';

// 諸手当の種類（key はサーバー保存用、label は表示用）
const ALLOWANCE_TYPES = [
  { key: 'familyAllowance', label: '家族手当' },
  { key: 'housingAllowance', label: '住宅手当' },
  { key: 'dispatchAllowance', label: '派遣手当' },
  { key: 'cityAllowance', label: '都市手当' },
  { key: 'qualificationAllowance', label: '資格手当' },
];

const EMPTY_ALLOWANCE = ALLOWANCE_TYPES.reduce((acc, a) => ({ ...acc, [a.key]: '' }), {});

const AllowanceForm = ({ onBack, isFirstForm }) => {
  const navigate = useNavigate();
  const [amounts, setAmounts] = useState(EMPTY_ALLOWANCE);
  const [saving, setSaving] = useState(false);

  const handleChange = (key, value) => {
    // 半角数字のみ（最大8桁）
    const digits = value.replace(/\D/g, '').slice(0, 8);
    setAmounts((prev) => ({ ...prev, [key]: digits }));
  };

  const total = ALLOWANCE_TYPES.reduce((sum, a) => sum + (Number(amounts[a.key]) || 0), 0);

  const handleBack = () => { if (onBack) onBack(); else navigate('/applications'); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (total <= 0) {
      alert('いずれかの手当に金額を入力してください。');
      return;
    }
    if (!window.confirm('諸手当を申請してもよろしいですか？')) return;

    setSaving(true);
    try {
      const formData = ALLOWANCE_TYPES.reduce(
        (acc, a) => ({ ...acc, [a.key]: Number(amounts[a.key]) || 0 }),
        {}
      );
      formData.totalAllowance = total;

      await api.post('/api/forms/submit_allowance/', {
        category: 'ALLOWANCE',
        title: '諸手当申請',
        formData,
      });
      alert('諸手当を申請しました。');
      navigate('/applications/history');
    } catch (err) {
      alert('申請に失敗しました。もう一度お試しください。');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container form-container">
      <h3>諸手当</h3>
      <p style={{ fontSize: '13px', color: '#64748b' }}>
        申請する手当の金額を入力してください（申請しない手当は空欄のままで構いません）。
      </p>

      <form onSubmit={handleSubmit}>
        {ALLOWANCE_TYPES.map((a) => (
          <div className="mb-3" key={a.key}>
            <label htmlFor={a.key} className="form-label" style={{ fontWeight: 'bold' }}>{a.label}</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <input
                type="text"
                id={a.key}
                name={a.key}
                className="form-control"
                value={amounts[a.key]}
                onChange={(e) => handleChange(a.key, e.target.value)}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="0"
                style={{ flex: 1 }}
              />
              <span>円</span>
            </div>
          </div>
        ))}

        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '10px', textAlign: 'right', fontWeight: 'bold' }}>
          合計: <span style={{ color: '#ea580c', fontSize: '1.1rem' }}>{total.toLocaleString('ja-JP')} 円</span>
        </div>

        <div className="button-group">
          <button type="submit" className="btn-submit" disabled={saving}>{saving ? '送信中...' : '送信'}</button>
          <button type="button" className="btn-back" onClick={handleBack}>{onBack && !isFirstForm ? '前へ' : '戻る'}</button>
        </div>
      </form>
    </div>
  );
};

export default AllowanceForm;
